import { css } from '@emotion/react'
import { Flow, Tag, Text } from 'bold-ui'
import { VisualizarAtendimentoButton } from 'components/atendimento/VisualizarAtendimentoButton'
import CheckPermission from 'components/auth/CheckPermission'
import { CpfOrCns } from 'components/CpfOrCns'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import Permissions from 'types/Permissions'
import { formatDateAndHoursMinutes } from 'util/date/formatDate'
import {
  TipoAtendimentoHistoricoProps,
  tipoRegistroHistoricoData as tipoAtendimentoHistoricoData,
} from 'view/atendimentos/detail/historico/model/model-historico'
import { getCpfOrCnsTitle } from 'view/cidadao/utils-cidadao'

import { convertAssinaturaModelToHistoricoModel } from '../converter-assinaturaEletronicaAtend'
import {
  AssinaturaEletronicaAtendTableRowModel,
  statusAssinaturaAtendimentoRecord,
} from '../model-assinaturaEletronicaAtend'
import { AssinarAtendimentoDigitalButton } from './AssinarAtendimentoDigitalButton'
import { BaixarAtendimentoDigitalButton } from './BaixarAtendimentoDigitalButton'

export const renderDataHora = (row: AssinaturaEletronicaAtendTableRowModel) => {
  return <Text>{formatDateAndHoursMinutes(row.dataRegistro)}</Text>
}

type InnerTipoAtendimentoHistoricoRecord = Partial<Record<TipoAtendimentoProfissional, TipoAtendimentoHistoricoProps>>

export const renderTipoAtendimento = (row: AssinaturaEletronicaAtendTableRowModel) =>
  (tipoAtendimentoHistoricoData as InnerTipoAtendimentoHistoricoRecord)[row.tipoAtendimento]?.descricao

export const renderCidadao = (row: AssinaturaEletronicaAtendTableRowModel) => {
  const cpfOrCnsTitle = getCpfOrCnsTitle(row.cidadao)
  return (
    <Flow direction='vertical' gap={0}>
      <Text fontWeight='bold'>{(row.cidadao?.nomeSocial ?? row.cidadao?.nome)?.titleCase() ?? '-'}</Text>
      <Flow direction='horizontal' gap={0}>
        {cpfOrCnsTitle}
        <CpfOrCns cpf={row.cidadao?.cpf} cns={row.cidadao?.cns} defaultText='Cidadão sem CPF/CNS' />
      </Flow>
    </Flow>
  )
}

export const renderTags = (row: AssinaturaEletronicaAtendTableRowModel) => {
  const statusTag = statusAssinaturaAtendimentoRecord(row.horarioAssinatura)[row.statusAssinatura || 'NAO_ASSINADO']

  return (
    <Tag
      type={statusTag.type}
      icon={statusTag.icon}
      style={css`
        color: ${statusTag.color};
        background: ${statusTag.backgroundColor};
      `}
    >
      {statusTag.descricao}
    </Tag>
  )
}

export const renderActions = (row: AssinaturaEletronicaAtendTableRowModel, refetch: () => void) => {
  const historicoModel = (tipoAtendimentoHistoricoData as InnerTipoAtendimentoHistoricoRecord)[row.tipoAtendimento]
  const dataOrTurno = formatDateAndHoursMinutes(row.dataRegistro)
  const historicoAtendimento = convertAssinaturaModelToHistoricoModel(row)

  return (
    <Flow direction='horizontal' justifyContent='flex-end'>
      <BaixarAtendimentoDigitalButton row={row} />
      <CheckPermission permission={Permissions.visualizarProntuario}>
        <VisualizarAtendimentoButton
          modalTitle={historicoModel?.descricao ?? ''}
          dataOrTurno={dataOrTurno}
          modalTitleColor={historicoModel?.iconColor ?? ''}
          historicoAtendimento={historicoAtendimento}
          cidadao={row.cidadao}
          tooltip='Visualizar registro'
          isAtendimentoAssinado={row.isAtendimentoAssinado}
        />
      </CheckPermission>
      <AssinarAtendimentoDigitalButton row={row} refetch={refetch} />
    </Flow>
  )
}
